// @flow

import type { Match } from 'react-router-dom';

import type { InsuranceType, Insurer } from '../types/commonTypes';

export const insurerCaption = (insurer: Insurer): string =>
  insurer === 'RSA' ? 'Intact' : insurer;

export const insuranceTypeParameter = (match: Match): InsuranceType =>
  // $FlowFixMe Casting type param to InsuranceType
  match.params.type;
